@if (isVisible) {
  <div id="xmlImportModal" class="modal-overlay">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">
            <i class="fa fa-file-code-o"></i> Import Players from XML
          </h2>
        </div>
        <div class="modal-body">
          <p class="text-muted m-b">
            Select an XML file containing player data to import into this tournament.
          </p>
          <div class="form-group">
            <label class="control-label">XML File:</label>
            <div class="file-input-wrapper">
              <input
                type="file"
                id="xmlFileInput"
                accept=".xml"
                (change)="onFileSelected($event)"
                class="file-input"
                />
                <label for="xmlFileInput" class="btn btn-white btn-block">
                  <i class="fa fa-folder-open"></i> Choose XML File
                </label>
              </div>
              @if (fileName) {
                <div class="m-t-sm">
                  <div class="alert alert-info">
                    <i class="fa fa-file-o"></i>
                    <strong>Selected:</strong> {{ fileName }}
                  </div>
                </div>
              }
              @if (selectedFile && !isValidFile) {
                <div class="m-t-sm">
                  <div class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i>
                    Please select a valid XML file.
                  </div>
                </div>
              }
            </div>
            <div class="alert alert-warning m-t">
              <i class="fa fa-info-circle"></i>
              <strong>Note:</strong> The XML file must follow the expected player data format. Invalid data will be rejected.
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeModal()">
              <i class="fa fa-times"></i> Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary"
              (click)="confirmImport()"
              [disabled]="!isValidFile"
              >
              <i class="fa fa-upload"></i> Import
            </button>
          </div>
        </div>
      </div>
    </div>
  }
